import { isValidPassword } from '../validators';
import { Localization } from '../../../localization/localization';
import { ErrorToolTip, TooltipDirection } from '../../newErrorToolTip';
import { setNewEmailPassword, SetNewEmailPasswordRequest } from './setNewEmailPassword';
import { JsFormResponseHandlerObject } from '../jsFormTypes';
import { Url } from '../url';
import { SetNewPasswordResponse } from '../../../api/hub-responses/set-new-password-response';
import { FormHandlers } from '../formHandlers';

FormHandlers.registerBeforeSendHandler('before_send_new_password_form', validateNewPasswordForm);
FormHandlers.registerSendRequestHandler('new_password_form_send_request', newPasswordFormSendRequest);
FormHandlers.registerAfterSendHandler('newpass_form_handler', newPassFormHandler);

function validateNewPasswordForm(): boolean {
    const currentPasswordInput = $('input[name=current-password]');
    const currentPassword = currentPasswordInput.val()
        .toString()
        .trim();
    const newPasswordInput = $('input[name=new-password]');
    const newPassword = newPasswordInput.val()
        .toString()
        .trim();

    if (!isValidPassword(currentPassword)) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            currentPasswordInput,
            TooltipDirection.BOTTOM,
            Localization._n('errors.pass_empty')
        );
        return false;
    }

    if (newPassword !== currentPassword) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            newPasswordInput,
            TooltipDirection.UP,
            Localization._n('errors.pass_c_fail')
        );
        return false;
    }

    return true;
}

function newPasswordFormSendRequest(form: JQuery): Promise<SetNewPasswordResponse> {
    const password = $(form).find('input[name=current-password]')
        .val()
        .toString()
        .trim();
    const url = new URL(window.location.href);
    const token = url.searchParams.get('token');
    const expires = parseInt(url.searchParams.get('expires'));
    let email = url.searchParams.get('email');
    if (email !== null) {
        email = decodeURIComponent(email).trim();
    }

    const setNewEmailPasswordRequest: SetNewEmailPasswordRequest = {
        email,
        expires,
        locale: window.app.config.locale,
        password,
        token
    };

    return setNewEmailPassword(setNewEmailPasswordRequest);
}

function newPassFormHandler(data: JsFormResponseHandlerObject<SetNewPasswordResponse>) {
    const parent = data.form.parent();
    const response = data.response;

    if (response.error) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('input[name=current-password]', parent),
            TooltipDirection.BOTTOM,
            response.error.message
        );
        return;
    }

    data.form.hide();
    $('.js-response', parent).show();

    $('.js-response input', parent).on('click', () => {
        window.location.href = Url.getNoLangUrl('restore/to-login');
    });
}
